import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Plus } from '@phosphor-icons/react';
import AdvanceDataTable from '@/components/core/advance-data-table/advance-data-table';
import { useServerTable } from '@/hooks/use-server-table';
import { mergeWhere } from '@/lib/table-query';
import { createOfferTableColumns } from '../../components/offer-table/offer-table-columns';
import { useGetConditionalOffers } from '../../hooks/use-offers';
import { DEFAULT_CONDITIONAL_OFFERS_ORDER } from '../../graphql/queries';
import { ConditionalOffersPagingResult } from '../../types/offer.types';
import { PageHeader } from '@/components/core';

export const OfferListPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { pagination, order, columnWhere, tableProps } = useServerTable({
    pageSize: 15,
    defaultOrder: DEFAULT_CONDITIONAL_OFFERS_ORDER,
  });

  const { data, isLoading, error } = useGetConditionalOffers({
    pageNo: pagination.pageIndex + 1,
    pageSize: pagination.pageSize,
    filter: mergeWhere({}, columnWhere),
    order,
  });
  const result = (data as { ConditionalOffers?: ConditionalOffersPagingResult })?.ConditionalOffers;
  const items = result?.items ?? [];
  const totalCount = result?.totalCount ?? 0;

  const columns = createOfferTableColumns({ t });

  return (
    <div className="flex w-full flex-col gap-4">
      <PageHeader
        title={t('CONDITIONAL_OFFERS')}
        actions={[
          {
            label: t('ADD_PROFILE'),
            icon: <Plus className="size-5" />,
            onClick: () => navigate('/hr/conditional-offers/builder'),
          },
        ]}
      />

      <AdvanceDataTable
        {...tableProps}
        data={items}
        columns={columns}
        isLoading={isLoading}
        error={error instanceof Error ? error : null}
        pagination={{
          pageIndex: pagination.pageIndex,
          pageSize: pagination.pageSize,
          totalCount,
        }}
        isExpandRowContent={false}
        mobileView="cards"
      />
    </div>
  );
};
